import * as vuex from 'vuex-class';
import { IEditorUiState } from '@/editor/editor-block/store/editor-ui.types';
import { EContext } from '@/editor/types/enums';

export const namespace = 'editorUi';

export const editorUiNamespace = 'editor/editorUi';

export const EditorUi = vuex.namespace(editorUiNamespace);

export enum EEditorUiAction {
  SetSelection = 'setSelection',
  ResetSelection = 'resetSelection',
  SetHover = 'setHover',
  ResetHover = 'resetHover',
  UpdateTextMenuState = 'updateTextMenuState',
  UpdateImageMenuState = 'updateImageMenuState',
  TriggerMenuCommand = 'triggerMenuCommand',
  CreateImage = 'createImage',
  CreateImageSuccess = 'createImageSuccess',
  CreateImageFailed = 'createImageFailed',
  ResetCreateImage = 'resetCreateImage',
  SetContext = 'setContext',
  EnqueueRequest = 'enqueueRequest',
  DequeueRequest = 'dequeueRequest',
  ProcessQueue = 'processQueue',
  ProcessQueueSuccess = 'processQueueSuccess',
  ProcessQueueFailed = 'processQueueFailed',
  SetBlockToUpdate = 'setBlockToUpdate',
}

export enum EEditorUiMutation {
  SetSelection = 'setSelection',
  ResetSelection = 'resetSelection',
  SetHover = 'setHover',
  ResetHover = 'resetHover',
  UpdateTextMenuState = 'updateTextMenuState',
  UpdateImageMenuState = 'updateImageMenuState',
  TriggerMenuCommand = 'triggerMenuCommand',
  SetImageUploaded = 'setImageUploaded',
  SetImageUploading = 'setImageUploading',
  SetImageUploadFailed = 'setImageUploadFailed',
  ResetImageUpload = 'resetImageUpload',
  SetContext = 'setContext',
  EnqueueRequest = 'enqueueRequest',
  DequeueRequest = 'dequeueRequest',
  SetIsUpdating = 'setIsUpdating',
  EmptyQueue = 'emptyQueue',
  SetBlockToUpdate = 'setBlockToUpdate',
}

export enum EEditorUiGetter {
  Context = 'context',
}

export const state: IEditorUiState = {
  context: EContext.Document,
  selected: {
    nodeId: '',
    cellId: '',
    rowId: '',
    sectionId: '',
    contentId: '',
  },
  hovered: {
    nodeId: '',
    rowId: '',
  },
  textMenuState: {
    bold: false,
    italic: false,
    underline: false,
    strike: false,
    link: false,
    paragraph: false,
    heading1: false,
    heading2: false,
    subHeading: false,
    label: false,
    bulletList: false,
    orderedList: false,
    alignLeft: false,
    alignCenter: false,
    alignRight: false,
    alignJustify: false,
    listToggle: false,
    undo: false,
    redo: false,
    mergeTagId: '',
    linkUrl: '',
  },
  imageMenuState: {
    heading: false,
    caption: false,
  },
  menuCommand: undefined,
  imageUpload: {
    imageUploaded: undefined,
    imageUploadFailed: false,
    isUploading: false,
    contentId: undefined,
  },
  updateQueue: [],
  isUpdating: false,
  blockToUpdate: undefined,
};
